
export const Navlinks = [
    {
        id: 'home',
        label: 'Home',
    },
    {
        id: 'projects',
        label: 'Projects',
    },
    {
        id: 'skills',
        label: 'Skills',
    },
    {
        id: 'resume',
        label: 'Resume',
    },
    {
        id: 'contact',
        label: 'Contact',
    },
];



